import React, { useEffect, useState, useCallback } from 'react'
import { useHistory } from 'react-router-dom'
import { Flex } from 'reflexbox'
import { useQuery, useMutation } from '@apollo/react-hooks'
import { clientsQueries } from '../../graphql/queries'
import { clientsMutations } from '../../graphql/mutations'
import Table from 'ui-components/lib/components/Table'
import useAlertStack from 'ui-components/lib/hooks/useAlertStack'
import AccountUserModal from '../../components/Modal/AccountUserModal'
import { FormTitle } from '../../components'
import Breadcumb from 'ui-components/lib/components/BreadCrumb'
import { ReactComponent as TrashEmpty } from "../../images/icons/trash-empty.svg";
import { ReactComponent as EditIcon } from "../../images/icons/edit_icon.svg";
import './styles.css'

const MyTeam = () => {
  const history = useHistory()
  const { showMessage } = useAlertStack()
  const [openAddAccountUsers, setOpenAddAccountUsers] = useState(false)
  const [accountUsers, setAccountUsers] = useState([])
  const [accountUserId, setAccountUserId] = useState('')

  const { data: dataAccountTypes } = useQuery(clientsQueries.GET_ACCOUNT_TYPES)
  const { data: dataAccountUsers, loading: loadingAccountUsers, refetch: refetchAccountUsers } = useQuery(clientsQueries.GET_ACCOUNT_USERS)

  const [deleteAccountUser] = useMutation(clientsMutations.DELETE_ACCOUNT_USER, {
    onCompleted() {
      showMessage({
        title: 'Usuário excluído com sucesso',
        message: 'Seu cadastro foi atualizado.',
        color: 'success',
        position: 'bottom-left',
        time: 4000,
      })
      refetchAccountUsers()
    },
    onError() {
      showMessage({
        title: 'Cadastro não atualizado',
        message: 'Ocorreu um erro ao excluir o usuário. Tente novamente mais tarde.',
        color: 'danger',
        position: 'bottom-left',
        time: 4000,
      })
    },
  })

  const handleDeleteAccountUser = useCallback((id) => {
    deleteAccountUser({ variables: { id } })
  },[deleteAccountUser])

  const handleManageAccountUser = (id) => {
    setOpenAddAccountUsers(true)
    setAccountUserId(id)
  }

  const handleCloseAccountUserModal = useCallback(() => {
    setOpenAddAccountUsers(false)
    refetchAccountUsers()
  },[refetchAccountUsers])

  useEffect(() => {
    if (!dataAccountUsers?.getAccountUsers || !dataAccountTypes?.getAccountTypes) return

    const accountUsersArray = dataAccountUsers.getAccountUsers.map((item, index) => {
      const filteredSelectedPackage = dataAccountTypes.getAccountTypes.filter(
        (typeItem) => typeItem._id === item.accountTypeId
      )
      const accountType = filteredSelectedPackage[0]?.type ?? (index === 0 ? 'Administrador proprietário' : '—')
      return {
        id: index === 0 ? '' : item._id,
        name: item.name ?? '—',
        email: item.email ?? '',
        document: item.document ?? '',
        accountType
      }
    })

    setAccountUsers(accountUsersArray)
  }, [dataAccountUsers, dataAccountTypes])

  const breadcrumbLinks = [
    {
      label: 'Home',
      onClick: () => history.push('/dashboard')
    },
    {
      label: 'Minha equipe'
    },
  ]


  return (
    <>
      <Flex width={1} justifyContent="center" flexDirection="column" className="service">
        <Flex width={1} mb={3} className="breadCrumb">
          <Breadcumb ml={-3} navigationLinks={breadcrumbLinks} />
        </Flex>
      </Flex>
      <div className="my-team-container">
        <div className="my-team-content-wrapper">
          <Flex mt={5} flexDirection="column" justifyContent="flex-start" width="100%">
            <FormTitle style={{marginBottom: '8px'}}>Minha equipe</FormTitle>
            <Flex justifyContent="flex-start" flex={1} className="my-team-table-wrapper">
            {Array.isArray(accountUsers) && (
              <Table
                flex={1}
                width={1}
                loading={loadingAccountUsers}
                overflow={'auto'}
                className="demand-table"
                style={{ cursor: 'pointer' }}
                headers={[
                  {
                    title: 'Nome',
                    key: 'name',
                    align: 'left',
                  },
                  {
                    title: 'Email',
                    key: 'email',
                    align: 'left',
                  },
                  {
                    title: 'Tipo',
                    key: 'accountType',
                    align: 'left',
                  },
                  {
                    title: 'Editar',
                    key: 'id',
                    align: 'left',
                    width: '60px',
                    cellComponent: ({ value, row }) => (
                      <button 
                        className={`my-team-action-button edit-button ${!row.id ? 'hidden' : ''}`}
                        style={{display: row.id ? 'flex' : 'none'}}
                        onClick={() => handleManageAccountUser(value)}
                        aria-label="Editar usuário"
                      >
                        <EditIcon />
                      </button>
                    ),
                  },
                  {
                    title: 'Excluir',
                    key: 'id',
                    align: 'left',
                    width: '60px',
                    cellComponent: ({ value, row }) => (
                      <button 
                        className={`my-team-action-button delete-button ${!row.id ? 'hidden' : ''}`}
                        style={{display: row.id ? 'flex' : 'none'}}
                        onClick={() => handleDeleteAccountUser(value)}
                        aria-label="Excluir usuário"
                      >
                        <TrashEmpty />
                      </button>
                    ),
                  },
                ]}
                data={accountUsers}
              />
            )}
            </Flex>
            <button
              className="my-team-add-button"
              onClick={() => setOpenAddAccountUsers(true)}
            >
              Adicionar usuário
            </button>
          </Flex>
          <AccountUserModal
            openModal={openAddAccountUsers}
            handleClose={handleCloseAccountUserModal}
            userType={'Usuario'}
            userId={accountUserId}
          />
        </div>
      </div>
    </>
  )
}

export default MyTeam
